import { DEAL_TYPES, PROMO_CODE_TYPES } from '../../../../../services/exports/Constants';

export default {
  title: 'Aktionsangebote',
  view_more: 'Mehr anzeigen',
  badges: {
    PROMO: 'Promo',
    DEAL: 'Angebot',
    'FREE ITEM': 'Gratisartikel',
    REWARDS: 'Prämien',
  },
  deals: {
    [DEAL_TYPES.GOOGLE_REVIEW_PROGRAM]: {
      title: '+{{reward}} Extra Punkte',
      description: 'Bewerte uns auf Google',
    },
    [DEAL_TYPES.SMART_PRICING_RULE]: {
      title: 'Sonderangebot',
      description: 'Bereits automatisch angewandt',
    },
    buttons: {
      add: 'Hinzufügen',
      remove: 'Entfernen',
      show_details: 'Details anzeigen',
    },
    mobile_app_signup_bonus: {
      title: '{{amount}} AppAnmelde-Bonus',
      desc: 'Erhalte {{amount}} Cashback, wenn du dich in unserer App anmeldest.',
    },
    welcome_bonus: {
      title: '{{amount}} Willkommens-Bonus',
      desc: 'Erhalte {{amount}} Cashback, wenn du dich registrierst.',
    },
  },
  discounts: {
    title: '{{discount}} Rabatt',
    usage_threshold: '(MBW: {{amount}})',
    description: {
      [PROMO_CODE_TYPES.ONE_TIME_PROMO_CODE]: '{{discount}} Rabatt auf deine nächste Bestellung - Code: {{code}}',
      [PROMO_CODE_TYPES.MULTI_PROMO_CODE]:
        '{{discount}} Rabatt auf deine nächsten {{count}} Bestellungen - Code: {{code}}',
    },
  },
  feedback: {
    login:
      '<highlight>Log dich ein,</highlight> um diese Promo zu nutzen, damit wir sicherstellen, dass du sie noch nicht aufgebraucht hast. Login und versuche es erneut.',
  },
};
